export const StripeIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="28" height="28" fill="#625BF6" />
      <path
        d="M12.7811 10.967C12.7811 10.3242 13.3858 10.0769 14.3875 10.0769C15.8236 10.0769 17.6378 10.4561 19.074 11.1319V7.25822C17.5056 6.7143 15.956 6.5 14.3875 6.5C10.5512 6.5 8 8.24731 8 11.165C8 15.7143 15.1811 14.9891 15.1811 16.9507C15.1811 17.7088 14.4253 17.9561 13.3669 17.9561C11.7985 17.9561 9.79526 17.3956 8.20782 16.6374V20.5605C9.96534 21.2199 11.7417 21.5 13.3669 21.5C17.2976 21.5 20 19.8023 20 16.8517C19.9811 11.9396 12.7811 12.8132 12.7811 10.967Z"
        fill="white"
      />
    </svg>
  );
};
